export default __webpack_public_path__ + "static/media/cart-32.ecdf5d7d.svg";